import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MapMarkerFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8697 21.9188L11.8732 21.92C12.1049 22.0212 12.2343 21.9976 12.2343 21.9976C12.2343 21.9976 12.3637 22.0212 12.5966 21.92L12.599 21.9188L12.606 21.9153L12.6272 21.9059C12.7389 21.854 12.8491 21.7991 12.9578 21.7412C13.1766 21.6283 13.4824 21.4589 13.8482 21.2318C14.5776 20.7801 15.548 20.0955 16.5232 19.1556C18.4712 17.2782 20.4686 14.3432 20.4686 10.2343C20.4686 9.15297 20.2556 8.08221 19.8418 7.08318C19.428 6.08415 18.8215 5.1764 18.0569 4.41178C17.2922 3.64715 16.3845 3.04061 15.3855 2.6268C14.3864 2.21299 13.3157 2 12.2343 2C11.153 2 10.0822 2.21299 9.08318 2.6268C8.08415 3.04061 7.1764 3.64715 6.41178 4.41178C5.64715 5.1764 5.04061 6.08415 4.6268 7.08318C4.21299 8.08221 4 9.15297 4 10.2343C4 14.3421 5.99741 17.2782 7.94659 19.1556C8.76267 19.9394 9.65886 20.6353 10.6204 21.2318C10.9928 21.4631 11.3759 21.6766 11.7685 21.8718L11.8414 21.9059L11.8626 21.9153L11.8697 21.9188ZM12.2343 12.8811C12.9363 12.8811 13.6095 12.6022 14.1058 12.1058C14.6022 11.6095 14.8811 10.9363 14.8811 10.2343C14.8811 9.53236 14.6022 8.85915 14.1058 8.36279C13.6095 7.86643 12.9363 7.58757 12.2343 7.58757C11.5324 7.58757 10.8591 7.86643 10.3628 8.36279C9.86642 8.85915 9.58757 9.53236 9.58757 10.2343C9.58757 10.9363 9.86642 11.6095 10.3628 12.1058C10.8591 12.6022 11.5324 12.8811 12.2343 12.8811Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

MapMarkerFilledIcon.displayName = 'MapMarkerFilledIcon';
